import SEO from "../designSystem/SEO";
import Hero from "../designSystem/Hero";
import HomeBanner from "../../assets/images/homepage_01.png";
import HomeAdvice from "../../assets/images/homepage_02.png";
import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import { Link } from "react-router-dom";
import { ReactComponent as ResidentialMortgageIcon } from "../../assets/icons/capc_icons_residential_mortgages.svg";
import { ReactComponent as ProtectionIcon } from "../../assets/icons/capc_icons_protection.svg";
import { ReactComponent as BuyToLetIcon } from "../../assets/icons/capc_icons_buy-to-let_mortgages.svg";
import { ReactComponent as SpecialistLendingIcon } from "../../assets/icons/capc_icons_specialist_lending.svg";

const services = [
  {
    title: "Residential Mortgages",
    path: "/residential-mortgages",
    icon: ResidentialMortgageIcon,
    description: "Mortgage solutions for buyers, movers and remortgages.",
  },
  {
    title: "Protection",
    path: "/protection",
    icon: ProtectionIcon,
    description: "Insurance to protect your home, income and family.",
  },
  {
    title: "Buy-to-Let Mortgages",
    path: "/buy-to-let-mortgages",
    icon: BuyToLetIcon,
    description: "Mortgage advice for landlords and property investors.",
  },
  {
    title: "Specialist Lending",
    path: "/specialist-lending",
    icon: SpecialistLendingIcon,
    description: "Mortgage solutions for complex borrowing needs.",
  },
];

const ServiceIcon = ({ icon: Icon }) => (
  <Icon  />
);

const LandingPage = () => (
  <main className="landing-page">
    <SEO
      title="Your Trusted Mortgage & Protection Partner"
      description="Clear, personal mortgage and protection advice from CAPC."
      path="/"
    />

    <Hero
      className="landing-hero"
      backgroundImage={HomeBanner}
      subtitle=""
      title={``}
      titleAlign="left"
      subtitleAlign="left"
    >
      <div className="column gap-l text-left py-xxl ">
        <div className="nav-text text-white uppercase">
          tailored advisory service
        </div>
        <h1 className="text-white text-left">
          Your Trusted Mortgage & Protection Partner
        </h1>
        <div className="content text-white">
          Every client is different, which is why we take a personal approach to
          every application. We take the time to understand your needs, explain
          your options clearly and provide tailored advice to help you make
          confident financial decisions.
        </div>
        <PrimaryButton text="contact us" />
      </div>
    </Hero>
    <section className="background-container bg-white">
      <div className="content-container">
        <div className="column-center gap-l text-center">
          <div className="content text-primary-2">
            Christopher Allen Private Clients is a boutique mortgage and
            protection brokerage specialising in high net worth clients.
            Assisting with residential and buy to let. We provide bespoke
            mortgage advice.  
          </div>
          <div className="content text-primary-2">
            We work closely with high street lenders, specialist providers and
            private banks to assist our clients in achieving their financial
            goals. Our advisers have access to over 12,000 mortgages from more
            than 90 UK lenders, including exclusive deals only available through
            us.
          </div>
          <div className="content text-primary-2">
            CAPC has become one of the premium mortgage brokers for an
            increasing number of accountancy firms around the UK. This allows
            accountants to provide enhanced support services to their clients.
            Your home may be repossessed if you do not keep up repayments on
            your mortgage.
          </div>
        </div>
      </div>
    </section>
    <section className="background-container bg-primary-2">
      <div className="content-container">
        <div className="grid4 gap-xxl">
          {services.map((value) => (
            <Link
              className="service-card-link column-center gap-xl text-center"
              key={value.title}
              to={value.path}
              aria-label={`Learn more about ${value.title}`}
            >
              <ServiceIcon icon={value.icon} />
              <div className="column gap-m align-center">
                <div className="subtitle-semibold text-white">
                  {value.title}
                </div>
                <div className="content text-white">{value.description}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
    <section className="background-container bg-white">
      <div className="content-container row-center grid2 gap-xxxxxl row-center">
        <img
          src={HomeAdvice}
          alt="Traditional residential property with bay windows and landscaped greenery"
          className="hero-image"
        />
        <div className="column gap-l">
          <h3 className="text-primary-2">Why Choose CAPC Mortgages?</h3>
          <div className="content text-primary-2">
            We pride ourselves on delivering a personal service, taking the time
            to understand your circumstances and goals. With access to a wide
            range of mortgage options from across the UK market, we provide
            expert guidance throughout your mortgage journey. Our support
            continues after completion, helping you review your mortgage and
            protection needs as your circumstances change.
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default LandingPage;
